import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {MerlinxPassengers} from '../../../shared/interfaces/merlinx-passengers';

@Component({
  selector: 'app-engine-merlinx-passengers-modal',
  templateUrl: './engine-merlinx-passengers-modal.component.html',
  styleUrls: ['./engine-merlinx-passengers-modal.component.scss']
})
export class EngineMerlinxPassengersModalComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal) { }

  @Input() passengers: MerlinxPassengers;

  ngOnInit(): void {
  }

  trackByIdx(index: number, obj: any): any {
    return index;
  }

  confirm(): void {
    this.activeModal.close(this.passengers);
  }

  addAdult(): void {
    this.passengers.adultsNum++;
  }

  removeAdult(): void {
    if (this.passengers.adultsNum > 1) {
      this.passengers.adultsNum--;
    }
  }

  addChild(): void {
    this.passengers.childrenNum++;
    this.passengers.childrenAges.push(new Date());
  }

  removeChild(): void {
    if (this.passengers.childrenNum > 0) {
      this.passengers.childrenNum--;
      this.passengers.childrenAges.pop();
    }
  }

}
